export const calcDiff = (value1: number = 0, value2: number = 0) => {
  if (value1 === null || !value1) {
    value1 = 0
  }
  if (value2 === null || !value2) {
    value2 = 0
  }
  if (value1 === 0 && value2 > 0) {
    return value2
  }
  if (value1 === 0 && value2 === 0) {
    return 0
  }
  if (value1 >= 0 && value2 === 0) {
    return -value1
  }

  return value2 - value1
}

export const calcDiff2 = (value1: number = 0, value2: number = 0): number | undefined => {
  if (value1 === null || !value1) {
    return undefined
  }
  if (value2 === null || !value2) {
    return undefined
  }

  return value2 - value1
}
